import React from "react";
import { connect } from "react-redux";
import { SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import { EMPTY_STRING } from "../../../constants";
import { ReactComponent as ChevronLeftIcon } from "../../../assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "../../../assets/icons/chevron-right.svg";

import { truncateString } from "../../../shared";
import { eventBookingActions } from "../../../redux/actions";
import SliderWrapper from "../../../shared/components/Slider/SliderWrapper";
import CustomTooltip from "../../../shared/components/ToolTip/CustomTooltip";
import useResponsiveView from "../../../shared/hooks/useResponsiveView";

const EventSelection = (props) => {
  const { selectedEventId, handleEventClick, isDisabled = false } = props;

  const currentIndex = props.formState?.findIndex(
    (e) => e.id === selectedEventId,
  );

  const isNavigationAllowed = (eventId) => {
    if (!isDisabled) return true;
    const targetIndex = props.formState.findIndex((e) => e.id === eventId);

    return targetIndex <= currentIndex;
  };

  const { isMobileView } = useResponsiveView();

  return (
    <div className="event-slider-container">
      <div className="row">
        <div className="col-12 px-xl-0">
          <div className="slider-container">
            {props.formState?.length > 0 && (
              <SliderWrapper
                spaceBetween={0}
                sliderHeight={"70px"}
                showPagination={false}
                PrevIcon={ChevronLeftIcon}
                NextIcon={ChevronRightIcon}
                prevButtonClass="event-selection-icon event-selection-icon-prev"
                nextButtonClass="event-selection-icon event-selection-icon-next end-0"
              >
                {props.formState.map((event, _) => (
                  <SwiperSlide key={event?.id} style={{ width: "fit-content" }}>
                    <div
                      className={`d-flex justify-content-center align-items-center ${
                        selectedEventId === event?.id ? EMPTY_STRING : "mt-1"
                      }`}
                    >
                      <p
                        onClick={() =>
                          isNavigationAllowed(event?.id) &&
                          handleEventClick(event)
                        }
                        className={`text-content m-0 w-100 ${
                          selectedEventId === event?.id
                            ? "event-name-selected"
                            : "event-name"
                        } ${isNavigationAllowed(event?.id) ? "cursor-pointer" : "cursor-not-allowed"}`}
                        title={!isMobileView ? event.eventName : undefined}
                      >
                        {truncateString(event.eventName, 18)}
                      </p>

                      {isMobileView && event.eventName.length > 18 && (
                        <CustomTooltip
                          id={`tooltip-${event.id}`}
                          title={event.eventName}
                          arrow
                          placement="right"
                        >
                          <span tabIndex={_} className="ml-1">
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              className="info-icon"
                            />
                          </span>
                        </CustomTooltip>
                      )}
                      <span className="divider mx-3"></span>
                    </div>
                  </SwiperSlide>
                ))}
              </SliderWrapper>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  selectedEventId: state.eventBooking.selectedEventId,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setEventName: (data) => dispatch(eventBookingActions.setEventName(data)),
});

// mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(EventSelection);
